export const version = "units/5.5.0";
//# sourceMappingURL=_version.js.map